export default __webpack_public_path__ + "static/media/PNG.b033f2ed.svg";